import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

const useKYCStatusRedirect = (selectedPath) => {
  const { user, school } = useStateContext();
  const history = useHistory();

  useEffect(() => {
    if (!user) return; // If user data is not available, do nothing
    if (!school && (user.is_school || user.role === 0 || user.role === 2 || user.role === 3)) return; // If school data is not available for school/admin/burser/academic-admin users, do nothing

    const redirectBasedOnKYCStatus = () => {
      const currentPath = history.location.pathname;
      if (school.kyc_progress === 0) {
        if (currentPath !== '/onboarding/kyc') {
          history.push('/onboarding/kyc');
        }
      } else if (selectedPath && !currentPath.startsWith(selectedPath)) {
        history.push(selectedPath);
      }
    };
    
    // Check user role instead of just is_school
    // Role 0 = Admin, Role 1 = Teacher, Role 2 = Burser, Role 3 = Academic Admin
    if (user.is_school || user.role === 0 || user.role === 2 || user.role === 3) {
      // Admin (role 0), Burser (role 2), Academic Admin (role 3), or school users should use KYC redirect logic
      redirectBasedOnKYCStatus();
    } else if (user.role === 1) {
      const currentPath = history.location.pathname;
      if (!currentPath.startsWith('/teacher')) {
        history.push('/teacher');
      }
    }
  }, [school, history, selectedPath, user]);

  return null; // This hook doesn't return any JSX
};

export default useKYCStatusRedirect;
